import React from "react"
import { graphql, Link } from "gatsby"
import { Container, Column, Columns, Content } from "bloomer"

import Layout from "../components/layout"
import SEO from "../components/seo"

const fmtDate = iso => {
  if (!iso) return ""
  const [y, m, d] = iso.split("T")[0].split("-")
  return `${d}/${m}/${y}`
}

export default function ArtigosList({ data }) {
  const edges = data.allMarkdownRemark.edges
  return (
    <Layout>
      <SEO
        title="Artigos de Astrologia e Esoterismo | EstrelaGuia"
        description="Guias e curiosidades sobre astrologia, signos, tarot, anjos e esoterismo, explicados de forma simples."
      />
      <Container>
        <Columns>
          <Column>
            <Content>
              <h1>Artigos</h1>
              <p>Astrologia, signos, tarot e esoterismo explicados de forma simples.</p>
            </Content>
            <div className="artigo-list">
              {edges.map(({ node }) => (
                <Link key={node.fields.slug} to={node.fields.slug} className="artigo-card">
                  {node.frontmatter.heroImage && (
                    <img src={node.frontmatter.heroImage} alt={node.frontmatter.imageAlt || node.frontmatter.title} />
                  )}
                  <div className="artigo-card-body">
                    <span className="artigo-cat">{node.frontmatter.category}</span>
                    <h2>{node.frontmatter.title}</h2>
                    <p>{node.frontmatter.description || node.excerpt}</p>
                    <span className="artigo-card-date">{fmtDate(node.frontmatter.date)}</span>
                  </div>
                </Link>
              ))}
            </div>
          </Column>
        </Columns>
      </Container>
    </Layout>
  )
}

export const query = graphql`
  query artigosListQuery($skip: Int!, $limit: Int!) {
    allMarkdownRemark(
      filter: { fields: { collection: { eq: "artigos" } } }
      sort: { fields: [frontmatter___date], order: DESC }
      limit: $limit
      skip: $skip
    ) {
      edges {
        node {
          excerpt(pruneLength: 150)
          fields {
            slug
          }
          frontmatter {
            title
            description
            date
            category
            heroImage
            imageAlt
          }
        }
      }
    }
  }
`
